module.exports = __webpack_public_path__ + "img/azarbaycan.b3370ba6.png";